(() => {
  const initializeAmbassadorSection = (section) => {
    if (!section || section.dataset.ambassadorInitialized === 'true') return;
    section.dataset.ambassadorInitialized = 'true';
    section.classList.add('is-ready');

    const revealItems = [...section.querySelectorAll('.ap-ambassador__reveal')];
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!('IntersectionObserver' in window) || reducedMotion) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
    } else {
      const revealObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      );

      revealItems.forEach((item) => revealObserver.observe(item));
    }

    section.querySelectorAll('a[href^="#Ambassador"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const target = document.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });

    const stage = section.querySelector('[data-story-stage]');
    if (!stage) return;

    const stories = [...stage.querySelectorAll('[data-story-index]')];
    const previousButton = stage.querySelector('[data-story-previous]');
    const nextButton = stage.querySelector('[data-story-next]');
    const counter = stage.querySelector('[data-story-current]');
    const tabs = [...stage.querySelectorAll('[data-story-go]')];
    let activeIndex = 0;
    let autoplayTimer;
    let touchStartX = 0;

    const showStory = (nextIndex, userInitiated = false) => {
      if (!stories.length) return;
      activeIndex = (nextIndex + stories.length) % stories.length;
      stories.forEach((story, index) => {
        const isActive = index === activeIndex;
        story.classList.toggle('is-hidden', !isActive);
        story.setAttribute('aria-hidden', String(!isActive));
      });
      tabs.forEach((tab, index) => {
        const isActive = index === activeIndex;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-pressed', String(isActive));
      });
      if (counter) counter.textContent = String(activeIndex + 1);
      if (userInitiated) restartAutoplay();
    };

    const stopAutoplay = () => window.clearInterval(autoplayTimer);
    const startAutoplay = () => {
      stopAutoplay();
      if (reducedMotion || stories.length < 2 || window.Shopify?.designMode) return;
      autoplayTimer = window.setInterval(() => showStory(activeIndex + 1), 6500);
    };
    const restartAutoplay = () => startAutoplay();

    previousButton?.addEventListener('click', () => showStory(activeIndex - 1, true));
    nextButton?.addEventListener('click', () => showStory(activeIndex + 1, true));
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => showStory(Number(tab.dataset.storyGo), true));
    });

    stage.addEventListener('mouseenter', stopAutoplay);
    stage.addEventListener('mouseleave', startAutoplay);
    stage.addEventListener('focusin', stopAutoplay);
    stage.addEventListener('focusout', (event) => {
      if (!stage.contains(event.relatedTarget)) startAutoplay();
    });
    stage.addEventListener(
      'touchstart',
      (event) => {
        touchStartX = event.changedTouches[0]?.clientX || 0;
        stopAutoplay();
      },
      { passive: true }
    );
    stage.addEventListener(
      'touchend',
      (event) => {
        const distance = (event.changedTouches[0]?.clientX || 0) - touchStartX;
        if (Math.abs(distance) > 48) showStory(activeIndex + (distance < 0 ? 1 : -1), true);
        else startAutoplay();
      },
      { passive: true }
    );

    startAutoplay();
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-ambassador-section]').forEach(initializeAmbassadorSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
